import { isNil } from 'lodash';
import { MBLoadingIndicator } from '@shared/components/loading';
import { useResponsiveFormContext } from '@shared/scenes/entity/components/ResponsiveFormContext';
import { useViewTemplateLayout } from '@shared/scenes/workflows/hooks';
import { EntityFormProps } from './EntityFormProps';
import { EntityFormResponsive } from './EntityFormResponsive';
import { EntityFormStatic } from './EntityFormStatic';

export function EntityForm(props: EntityFormProps) {
  const isResponsiveForms = useResponsiveFormContext();
  if (isResponsiveForms) {
    return <EntityFormWithLayout {...props} />;
  } else {
    return <EntityFormStatic {...props} />;
  }
}

function EntityFormWithLayout(props: EntityFormProps) {
  const { workflowTemplateId, viewTemplateId } = props;
  const { layout, loading } = useViewTemplateLayout(workflowTemplateId, viewTemplateId);

  if (loading || isNil(workflowTemplateId) || isNil(viewTemplateId)) {
    return <MBLoadingIndicator fill />;
  } else {
    return <EntityFormResponsive {...props} layout={layout} />;
  }
}
